import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { SingleBlock as SB} from '@process-advisor/process-miner/components/layout/singleBlock';
import { getColor } from '@process-advisor/process-miner/shared/theme';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { DataGrid } from '@process-advisor/process-miner/workflows/workFlowDataGrid';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { retrieveWorkFlowTransitions} from '@process-advisor/process-miner/processMiner/processMiner';
import { setWorkflowConfiguration } from '@process-advisor/process-miner/processMiner/processMiner';

export const SingleBlock = styled(SB)`
    align-items: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    height: 100%;
    background-color: ${getColor('white')};
`;

export type Row = {};

export const WorkFlowAnalysis = ({AppVersion,contextPath}) => {

    const [data, setData] = React.useState([]);
    const [rows, setRows] = React.useState([])
    const [label, setLabel] = React.useState('')

    React.useEffect(() => {
        setData(apiProvider.getWorkflowConfiguration)
    }, []);

    React.useEffect(() => {
        if (data.length === 0 ) setLabel('Import Workflow Configuration')
        else setLabel('Update Workflow Configuration')
        let tempRows = data.map((row, id) => ({ id, ...row }));
        setRows(tempRows)
    }, [data]);

    const retrieveWorkFlowProjectTransitions = async () => {

        let workflowConfiguration = await retrieveWorkFlowTransitions(AppVersion,contextPath)
        console.log(workflowConfiguration)
        setData(workflowConfiguration)
        setWorkflowConfiguration(workflowConfiguration)
    }



    return (
      <Wrapper>
        <DataGrid rows={rows} />
        <SingleBlock width="40%"></SingleBlock>
        <SingleBlock width="20%">
            <Button label={label} onClick={retrieveWorkFlowProjectTransitions} />
        </SingleBlock>
        <SingleBlock width="40%"></SingleBlock>
      </Wrapper>
    )
};

export default WorkFlowAnalysis;

